import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2025 from '../EcoClub2025';


const EcoClub1Class2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/ecoclubclass1/6.webp`;


  const photos = [
    {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
     {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Leaf Imprint
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 1  &  Date: 13 June 2025
        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Time spent among trees is never time wasted. Let’s embark on a Journey into Nature"

        <br/>
        </Typography> */}
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
      The Eco Club of National Public School, Yeshwanthpur organized a delightful activity titled “Leaf
Imprint” on 13 June 2025 for the enthusiastic students of Grade 1. The activity aimed to blend
creativity with environmental awareness in a fun and engaging way.
      <br></br>
     Children came prepared with a wide variety of leaves—differing in shape, size, and texture—from
their surroundings. Using vibrant colours, they carefully created beautiful leaf imprints on A4-size
sheets. The process helped them observe the uniqueness of each leaf and appreciate the patterns and
textures found in nature.
<br></br>
The activity not only allowed the students to explore their artistic skills but also encouraged them to
connect with nature and understand the importance of preserving it. Their colourful imprints were a
reflection of their imagination and a gentle reminder of the wonders of the natural world.
<br></br>
It was truly a joyful and enriching experience, and the young learners participated with great
excitement and enthusiasm, leaving a lasting imprint — both on paper and in their hearts.
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"In every leaf imprint, a little hand left behind a big love for nature."

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2025 />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoClub1Class2025;